import React, { FunctionComponent } from 'react'
import Svg, { G, Mask, Path } from 'react-native-svg'

type Props = {
  size?: number | string
}

export const WellnessCheckInBenefitIllustration: FunctionComponent<Props> = ({ size = 45 }) => {
  return (
    <Svg width={size} height={size} fill='none'>
      <Path
        d='M22.658.152c-3.106 0-6.12.533-8.957 1.583C6.945 4.239 2.196 9.79.67 16.965c-1.009 4.68-.88 9.006.396 13.223 1.63 5.385 5.628 9.927 10.972 12.46 2.652 1.26 5.7 1.979 9.056 2.137.431.02.87.03 1.305.03 2.693 0 5.402-.369 8.052-1.096.203-.05.397-.103.602-.164 2.381-.697 4.524-1.8 6.358-3.273 1.99-1.591 3.63-3.608 4.866-5.991.243-.47.476-.964.733-1.555 1.414-3.283 2.097-6.959 1.976-10.633-.057-1.625-.298-3.352-.716-5.137-.689-2.897-1.81-5.622-3.246-7.884a21.913 21.913 0 00-1.112-1.577c-2.58-3.328-6.599-5.663-11.62-6.75A26.62 26.62 0 0022.66.154V.152z'
        fill='#FFE9E3'
      />
      <Mask
        id='a'
        style={{
          maskType: 'alpha',
        }}
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={45}
        height={45}
      >
        <Path
          d='M22.658.152c-3.106 0-6.12.533-8.957 1.583C6.945 4.239 2.196 9.79.67 16.965c-1.009 4.68-.88 9.006.396 13.223 1.63 5.385 5.628 9.927 10.972 12.46 2.652 1.26 5.7 1.979 9.056 2.137.431.02.87.03 1.305.03 2.693 0 5.402-.369 8.052-1.096.203-.05.397-.103.602-.164 2.381-.697 4.524-1.8 6.358-3.273 1.99-1.591 3.63-3.608 4.866-5.991.243-.47.476-.964.733-1.555 1.414-3.283 2.097-6.959 1.976-10.633-.057-1.625-.298-3.352-.716-5.137-.689-2.897-1.81-5.622-3.246-7.884a21.913 21.913 0 00-1.112-1.577c-2.58-3.328-6.599-5.663-11.62-6.75A26.62 26.62 0 0022.66.154V.152z'
          fill='#FFE9E3'
        />
      </Mask>
      <G mask='url(#a)'>
        <Mask
          id='b'
          style={{
            maskType: 'alpha',
          }}
          maskUnits='userSpaceOnUse'
          x={-1}
          y={0}
          width={47}
          height={45}
        >
          <Path
            d='M45.135 22.148c-.06-1.712-.322-3.485-.735-5.247-.674-2.84-1.783-5.64-3.303-8.037a22.081 22.081 0 00-1.107-1.57c-2.85-3.676-7.17-5.72-11.592-6.678-4.924-1.067-10.161-.756-14.895.997C6.654 4.151 1.992 9.71.47 16.86c-.584 2.71-.755 5.77-.493 8.712h-.02c.15 1.672.453 3.303.905 4.804 1.683 5.559 5.77 9.97 10.978 12.438 2.82 1.339 5.972 2.004 9.175 2.155 3.273.152 6.596-.262 9.669-1.107.201-.05.393-.101.594-.162 2.407-.704 4.502-1.792 6.294-3.232 1.954-1.561 3.565-3.525 4.815-5.932.271-.524.513-1.047.745-1.581 1.47-3.415 2.125-7.12 1.994-10.796l.01-.01v-.001z'
            fill='#FFE9E3'
          />
        </Mask>
        <G mask='url(#b)'>
          <Path
            d='M33.694 29.235c.07-.165.838-1.171 1.52-.786.926.523-3.206 8.255-7.44 8.946-4.234.692 5.92-8.16 5.92-8.16z'
            fill='#85CCD5'
          />
          <Path
            d='M2.676 45.91c.144-.334 5.43-10.262 8.8-12.578 3.368-2.317 9.823-6.321 10.695-5.24.873 1.083-.661 2.522-2.649 4.527 0 0 5.628.264 6.981.347 1.353.084 5.3-4.412 6.245-4.845.946-.432 1.788-.059 1.428 1.15-.361 1.207-4.903 9.523-9.016 9.332 0 0-9.285 3.62-9.952 4.198-.667.58-3.538 4.201-3.538 4.201l-8.995-1.09.001-.002z'
            fill='#85CCD5'
          />
          <Path
            d='M34.602 28.414c.028.354-.03.82-.307 1.353-.807 1.558-3.704 6.77-7.036 8.485-1 .517-1.865.732-2.584.775-1.802.105-2.736-.867-2.786-.923l.268-.25c.066.073 1.69 1.741 4.937.074 3.236-1.664 6.083-6.798 6.877-8.33.19-.37.26-.697.27-.965 0 0 .143-.137.36-.22zM26.298 33.134h-.03c-4.402-.424-8.624-.226-8.666-.224a.183.183 0 01-.02-.365h.002c.043-.003 4.291-.202 8.72.225.102.01.175.1.165.2a.182.182 0 01-.171.164z'
            fill='#85CCD5'
          />
          <Path
            d='M12.726 38.197s1.715-2.043 5.072-2.779c3.357-.737 5.895-.846 8.54-2.997 2.645-2.152 4.78-4.25 5.984-3.57 1.307.737-4.808 9.043-7.826 10.402s-6.146 2.235-7.955 4.745c-1.809 2.51-2.522 3.546-2.522 3.546l-7.762-1.498 6.468-7.848z'
            fill='#85CCD5'
          />
          <Path
            d='M14.03 47.725a.183.183 0 01-.161-.288c.007-.01.736-1.065 2.525-3.548 1.487-2.064 3.809-3.03 6.267-4.052.578-.24 1.176-.489 1.76-.753 2.616-1.178 7.815-7.947 7.898-9.799.007-.148-.022-.242-.087-.278-.906-.512-2.605.909-4.57 2.553-.39.325-.793.662-1.208 1-2.183 1.775-4.326 2.19-6.806 2.669-.578.111-1.18.227-1.81.365-3.257.715-4.954 2.698-4.971 2.72a.182.182 0 11-.28-.236c.072-.085 1.794-2.1 5.173-2.841.634-.14 1.238-.255 1.818-.368 2.533-.49 4.533-.876 6.645-2.593.414-.338.817-.673 1.204-.998 2.157-1.802 3.86-3.226 4.986-2.59.134.075.29.244.272.614-.09 1.971-5.346 8.868-8.114 10.113-.59.266-1.19.516-1.77.757-2.41 1.003-4.685 1.948-6.11 3.928a240.634 240.634 0 00-2.521 3.542.183.183 0 01-.14.08v.003z'
            fill='#85CCD5'
          />
          <Path
            d='M33.694 29.235c.07-.165.838-1.171 1.52-.786.926.523-3.206 8.255-7.44 8.946-4.234.692 5.92-8.16 5.92-8.16z'
            fill='#DA9460'
          />
          <Path
            d='M2.676 45.91c.144-.334 5.43-10.262 8.8-12.578 3.368-2.317 9.823-6.321 10.695-5.24.873 1.083-.661 2.522-2.649 4.527 0 0 5.628.264 6.981.347 1.353.084 5.3-4.412 6.245-4.845.946-.432 1.788-.059 1.428 1.15-.361 1.207-4.903 9.523-9.016 9.332 0 0-9.285 3.62-9.952 4.198-.667.58-3.538 4.201-3.538 4.201l-8.995-1.09.001-.002z'
            fill='#DA9460'
          />
          <Path
            d='M34.602 28.414c.028.354-.03.82-.307 1.353-.807 1.558-3.704 6.77-7.036 8.485-1 .517-1.865.732-2.584.775-1.802.105-2.736-.867-2.786-.923l.268-.25c.066.073 1.69 1.741 4.937.074 3.236-1.664 6.083-6.798 6.877-8.33.19-.37.26-.697.27-.965 0 0 .143-.137.36-.22zM26.298 33.134h-.03c-4.402-.424-8.624-.226-8.666-.224a.183.183 0 01-.02-.365h.002c.043-.003 4.291-.202 8.72.225.102.01.175.1.165.2a.182.182 0 01-.171.164z'
            fill='#BF7C4F'
          />
          <Path
            d='M12.726 38.197s1.715-2.043 5.072-2.779c3.357-.737 5.895-.846 8.54-2.997 2.645-2.152 4.78-4.25 5.984-3.57 1.307.737-4.808 9.043-7.826 10.402s-6.146 2.235-7.955 4.745c-1.809 2.51-2.522 3.546-2.522 3.546l-7.762-1.498 6.468-7.848z'
            fill='#DA9460'
          />
          <Path
            d='M14.03 47.725a.183.183 0 01-.161-.288c.007-.01.736-1.065 2.525-3.548 1.487-2.064 3.809-3.03 6.267-4.052.578-.24 1.176-.489 1.76-.753 2.616-1.178 7.815-7.947 7.898-9.799.007-.148-.022-.242-.087-.278-.906-.512-2.605.909-4.57 2.553-.39.325-.793.662-1.208 1-2.183 1.775-4.326 2.19-6.806 2.669-.578.111-1.18.227-1.81.365-3.257.715-4.954 2.698-4.971 2.72a.182.182 0 11-.28-.236c.072-.085 1.794-2.1 5.173-2.841.634-.14 1.238-.255 1.818-.368 2.533-.49 4.533-.876 6.645-2.593.414-.338.817-.673 1.204-.998 2.157-1.802 3.86-3.226 4.986-2.59.134.075.29.244.272.614-.09 1.971-5.346 8.868-8.114 10.113-.59.266-1.19.516-1.77.757-2.41 1.003-4.685 1.948-6.11 3.928a240.634 240.634 0 00-2.521 3.542.183.183 0 01-.14.08v.003z'
            fill='#BF7C4F'
          />
        </G>
        <Path
          d='M28.075 8.074c-1.158.462-3.652 1.72-4.985 2.254v5.941c0 .222-.18.402-.401.402h-.74a.402.402 0 01-.401-.402v-5.934c0-.046.008-.09.023-.13-1.254-.494-3.55-1.398-4.897-1.934-.524-.209-.57-.921-.087-1.213.722-.432 1.819-.788 3.168-.271 1.568.6 2.23 1.935 2.507 2.843.251-.904.901-2.336 2.542-2.964 1.498-.574 2.685-.073 3.393.418.369.255.294.824-.122.99z'
          fill='#96CF51'
        />
        <Path
          d='M37.658 20.15c-1.2 1.985-4.063 4.772-5.053 4.929-.467.074-3.571-2.175-5.08-4.61-.846-1.358-1.196-2.782-.287-3.883.812-.983 1.702-1.194 2.521-1.055 1.465.246 2.678 1.617 2.678 1.617s2.008-2.638 4.547-.996c1.269.818 1.51 2.623.675 3.999h-.001z'
          fill='#F39172'
        />
        <Path
          d='M15.372 15.12c-1.056-.89-2.484-1.098-3.815-.877-1.286.215-2.643.762-3.43 1.845a4.074 4.074 0 00-.752 2.103c-.073 1.014.142 2.08.71 2.932.56.838 2.047 1.516 1.827 2.663-.08.409.446.572.774.507.091.099.212.177.352.169l1.32-.076.928.097c.19.02.338-.059.434-.18.259-.015.8.062.8-.249 0-.545-.08-1.262.126-1.723.204-.453.388-.661.728-.982.58-.548 1.031-1.205 1.254-1.978.447-1.548-.015-3.206-1.254-4.25h-.002z'
          fill='#FFCB3B'
        />
        <Path
          d='M14.205 18.523c.035-.643-.627-.952-1.087-.527-.289.266-.354.697-.41 1.071-.038.255-.063.512-.082.77-.275.115-.57.192-.87.216a2.875 2.875 0 00-.267-.8c-.283-.539-.886-1.113-1.517-.795-.624.314-.456 1.102-.031 1.508.383.367.913.526 1.462.537.034.344.031.695.016 1.033a10.722 10.722 0 01-.335 2.196c-.07.267.317.421.387.152.224-.857.357-1.734.372-2.62.004-.256 0-.519-.024-.779.27-.03.538-.095.788-.184-.003.104-.011.208-.013.313-.023 1.038-.009 2.078-.009 3.118 0 .276.413.317.413.038 0-1.214-.04-2.44.032-3.654.083-.044.165-.09.24-.14.472-.314.904-.845.936-1.452v-.001zm-3.462 1.421a1.348 1.348 0 01-.55-.32c-.155-.161-.34-.492-.153-.697.458-.505 1.044.396 1.185.768.045.117.075.239.104.36a2.37 2.37 0 01-.586-.11zm2.312-.336c.028-.48.102-1.442.57-1.382.51.066-.155 1.031-.317 1.181-.078.073-.163.14-.253.2z'
          fill='#fff'
        />
        <Path
          d='M9.873 23.235h4.645v2.826a.307.307 0 01-.306.306h-4.034a.307.307 0 01-.306-.306v-2.826h.001z'
          fill='#CDB8A6'
        />
      </G>
    </Svg>
  )
}
